import { Box } from '@chakra-ui/react'
import {
  ContentNotFound,
  FullWidthTwoColSection,
  Hero,
  InformationContactSection,
  Layout,
  PhotoAndVideoSliderSection,
  RelatedEvents,
  ScientificPublicationsollectionLinst,
  StickyHeader,
} from '@common'
import { ISSRPageData } from '@interfaces'
import { ConservationService } from '@services'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const ArtConservationScreen = ({
  pageData,
  global: { navigation },
}: ISSRPageData) => {
  const { asPath } = useRouter()
  const { t } = useTranslation()

  if (pageData.error) {
    return (
      <Layout
        title={t('nav:conservation')}
        navigation={navigation}
        path={asPath}
      >
        <ContentNotFound />
      </Layout>
    )
  }

  return (
    <Layout
      title={pageData.data.pageTitle || t('nav:conservation')}
      navigation={navigation}
      path={asPath}
    >
      <Hero
        bgImageUrl={pageData.data.hero.bgImageUrl}
        subTitle={pageData.data.hero.subTitle}
        title={pageData.data.hero.title}
        description={pageData.data.hero.description}
      />
      <Box
        as="main"
        pt={4}
        pb={{ base: 'padding.primary2', lg: 'padding.primary4' }}
      >
        <StickyHeader
          navs={pageData.data.stickyNavItems}
          containerProps={{
            zIndex: 3,
          }}
        />

        {pageData.data.fullWidthTwoColSections &&
          pageData.data.fullWidthTwoColSections.length > 0 && (
            <>
              {pageData.data.fullWidthTwoColSections.map((section) => (
                <FullWidthTwoColSection
                  key={section.data.id || ''}
                  htmlContent={section.data.htmlContent || ''}
                  id={section.contentId || ''}
                  imgUrl={section.data.imgUrl || ''}
                  isReverse={section.data.isReverse || ''}
                  title={section.data.title || ''}
                />
              ))}
            </>
          )}

        {pageData.data.scientificPublications &&
          pageData.data.scientificPublications.length > 0 && (
            <ScientificPublicationsollectionLinst
              stickyId={pageData.data.scientificPublications[0].contentId}
              sectionTitle={
                pageData.data.scientificPublications[0].contentTabLabel
              }
              collection={pageData.data.scientificPublications[0].data}
            />
          )}

        {pageData.data?.gallery &&
          pageData.data.gallery?.data &&
          pageData.data.gallery?.data.length > 0 && (
            <PhotoAndVideoSliderSection
              stickyId={pageData.data.gallery.contentId}
              sectionTitle={pageData.data.gallery.contentTabLabel}
              data={pageData.data.gallery.data}
              pb={{ base: 'padding.primary2', lg: 'padding.primary4' }}
              my={{ base: '0', lg: '0' }}
            />
          )}

        {pageData.data.conferencesAndSeminars &&
          pageData.data.conferencesAndSeminars.data.length > 0 && (
            <RelatedEvents
              stickyId={pageData.data.conferencesAndSeminars.contentId}
              title={pageData.data.conferencesAndSeminars.contentTabLabel}
              collection={pageData.data.conferencesAndSeminars.data}
              isWithoutEventInformationCard={true}
              containerProps={{
                pt: { base: 'padding.primary2', lg: 'padding.primary4' },
              }}
            />
          )}

        {pageData.data.contact && pageData.data.contact.length > 0 && (
          <InformationContactSection
            stickyId={pageData.data.contact[0].contentId}
            sectionTitle={pageData.data.contact[0].contentTabLabel}
            tel={pageData.data.contact[0].data.tel}
            fax={pageData.data.contact[0].data.faks}
            email={pageData.data.contact[0].data.email}
          />
        )}
      </Box>
    </Layout>
  )
}

export default ArtConservationScreen

export async function getServerSideProps({ locale }) {
  const pageData = {
    data: null,
    error: null,
  }

  try {
    const conservation = await ConservationService.getConservation(locale)

    pageData.data = conservation
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message }
    }
  }

  return {
    props: { pageData },
  }
}
